import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=249fd660&scoped=true"
import script from "./Treatment.vue?vue&type=script&lang=js"
export * from "./Treatment.vue?vue&type=script&lang=js"
import style0 from "./Treatment.vue?vue&type=style&index=0&id=249fd660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249fd660",
  null
  
)

export default component.exports